"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { Briefcase, Activity, History, Settings, MoreHorizontal } from "lucide-react";
import { MoreSheet, MORE_PATHS } from "./more-sheet";
import { useAuthUser, RESTRICTED_ALLOWED_PATHS } from "@/hooks/use-auth-user";

const mainItems = [
  // 대시보드는 상단 포트폴리오 탭 바로 이동 — 하단 네비에서 제거
  { href: "/holding", label: "보유종목", Icon: Briefcase },
  { href: "/performance", label: "성과", Icon: Activity },
  { href: "/trades", label: "거래내역", Icon: History },
  { href: "/settings", label: "설정", Icon: Settings },
];

export function BottomNav() {
  const pathname = usePathname();
  const [moreOpen, setMoreOpen] = useState(false);
  const isInMore = MORE_PATHS.includes(pathname);
  // 로그인 사용자는 허용 페이지 메뉴만 + '더보기' 숨김
  const { restricted } = useAuthUser();
  const items = restricted ? mainItems.filter((i) => RESTRICTED_ALLOWED_PATHS.includes(i.href)) : mainItems;

  return (
    <>
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-black/[0.08]"
        style={{
          background: "rgba(229, 229, 234, 0.92)",
          backdropFilter: "saturate(180%) blur(20px)",
          WebkitBackdropFilter: "saturate(180%) blur(20px)",
          paddingBottom: "max(8px, env(safe-area-inset-bottom))",
        }}
      >
        <ul className="flex items-stretch justify-around h-[56px]">
          {items.map((item) => {
            const isActive = pathname === item.href;
            const { Icon } = item;
            return (
              <li key={item.href} className="flex-1">
                <Link
                  href={item.href}
                  className={cn(
                    "flex flex-col items-center justify-center h-full gap-0.5 transition-colors",
                    isActive ? "text-neutral-900" : "text-black/65 active:text-black/80"
                  )}
                >
                  <Icon className="h-5 w-5" strokeWidth={isActive ? 2.2 : 1.7} />
                  <span className="text-2xs tracking-[-0.1px] leading-none">
                    {item.label}
                  </span>
                </Link>
              </li>
            );
          })}
          {!restricted && (
          <li className="flex-1">
            <button
              type="button"
              onClick={() => setMoreOpen(true)}
              className={cn(
                "flex flex-col items-center justify-center h-full w-full gap-0.5 transition-colors",
                isInMore ? "text-neutral-900" : "text-black/65 active:text-black/80"
              )}
            >
              <MoreHorizontal className="h-5 w-5" strokeWidth={isInMore ? 2.2 : 1.7} />
              <span className="text-2xs tracking-[-0.1px] leading-none">더보기</span>
            </button>
          </li>
          )}
        </ul>
      </nav>

      <MoreSheet open={moreOpen} onOpenChange={setMoreOpen} />
    </>
  );
}
